module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "leftbar-view elffy-dashboard",
    class: {
      'left-aside-toggle': _vm.toggle_aside
    }
  }, [_c('section', {
    staticClass: "main-container"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-3"
  }, [_c('smallBar', {
    attrs: {
      "user": _vm.user
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-9"
  }, [_c('div', {
    staticClass: "widget-wrap"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "widget-container"
  }, [(_vm.orders.length == 0) ? _c('div', {
    staticClass: "widget-content"
  }, [_c('p', [_vm._v("目前無任何付款紀錄。")])]) : _c('div', {
    staticClass: "widget-content"
  }, [_c('table', {
    staticClass: "table table-bordered"
  }, [_vm._m(1), _vm._v(" "), _vm._l((_vm.orders), function(order) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(order.no))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(order.name))]), _vm._v(" "), _c('td', [_vm._v("$ " + _vm._s(order.amount.toLocaleString()))]), _vm._v(" "), _c('td', [_c('div', {
      domProps: {
        "innerHTML": _vm._s(_vm.getOrderStatus(order.status))
      }
    })]), _vm._v(" "), _c('td', [(order.status == 'paid') ? _c('p', [_vm._v("付款時間：" + _vm._s(order.paid_at))]) : _vm._e(), _vm._v(" "), (order.status == 'refunded') ? _c('p', [_vm._v("退款時間：" + _vm._s(order.refund_at))]) : _vm._e()])])
  })], 2)])])])])])])]), _vm._v(" "), _c('simplert', {
    ref: "simplert",
    attrs: {
      "useRadius": true,
      "useIcon": true
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "widget-header block-header margin-bottom-0 clearfix"
  }, [_c('div', {
    staticClass: "pull-left"
  }, [_c('h3', [_vm._v("帳單一覽")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', {
    staticClass: "text-center"
  }, [_vm._v("帳單編號")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("內容")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("金額")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("狀態")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("時間")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1f497991","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Setting/Bills.vue
// module id = 672
// module chunks = 4